// extracted by mini-css-extract-plugin
export const container = "intro-module--container--1su7x";
export const innerBorder = "intro-module--innerBorder--1d8FW";
export const info = "intro-module--info--cXdl7";
export const bg = "intro-module--bg--3oBlq";